import { combineEpics } from "redux-observable";
import { push } from "react-router-redux";
import * as api from "./api";
import * as intercom from "core/integrations/intercom";

import { candidate, insider } from "routes/paths";

export default combineEpics(
  (action$, store) =>
    action$
      .ofType(api.sendInvitation.types.success)
      .do(({ payload }) => {
        const metadata = {
          invitee_email: payload.request.body.invitee_email
        };
        intercom.track("invited-friend", metadata);
      })
      .mapTo(push(candidate.inviteSuccess)),
  action$ =>
    action$
      .ofType(api.sendInsiderInvitation.types.success)
      .mapTo(push(insider.insiderReferralSuccess))
);



// WEBPACK FOOTER //
// ./src/modules/referral/epic.js